import type { FaireProductEntity } from "../../entity_types/product";

export const p_b5huj8yjrf: FaireProductEntity = {
  token: "p_b5huj8yjrf",
  type: "product",
  name: "KORY - [OPEN SIZING] Canvas Sneaker",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/07507c673a8e7f211ac52236bc477fbc056d0457171c24806ae45ec5c640950b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b5b2a72824050815cc10879927d9383faf428830363cbc2bc640529d01e5385.jpeg",
    "https://cdn.faire.com/fastly/5491c980ecff179eda9b14930370c022939716a64ba55ed6f6544fc32956200c.jpeg",
  ],
  priceDollars: 15.5,
  description:
    "Your off-duty staple, elevated. This suede low-top sneaker keeps it clean with soft neutral tones, tonal stitching, and a classic gum sole for that effortless, lived-in feel. Minimal, versatile, and made to go with everything.\n\nOOTD\nPair with straight-leg denim and a baby tee for an easy everyday look, or style with a linen set for something a little more polished. Also cute with a mini skirt and oversized sweater for that cozy-cool vibe.",
  tags: [],
  msrpDollars: 31,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:13.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
